
<v-container class="abstract-container lm-border pa-3" v-if="data.manufacturer && current" >
    <div class="v-flex w-100">
        <div>
            <div class="abstract-prev-step">1a</div>
            <div class="abstract-prev-bar"></div>
        </div>

        <div class="abstract-panel">
            <inc-abstract-company
                :manufacturer   = "data.manufacturer"
                :execution-date = "current.executionDate"
                :background     = "collective ? 'field-collective' : 'ro-background'"
            />

            <div class="abstract-group" v-if="current.description">
                <f-title :title="collective ? 'Beschreibung Anlage ' + unit.fabricNo : 'Beschreibung'" />
                <div class="abstract-info ro-background pa-3 pt-2">
                    <span>{{ current.description }}</span>
                </div>
            </div>

            <div class="abstract-group" v-if="current.measure">
                <f-title :title="collective ? 'Maßnahmen Anlage ' + unit.fabricNo : 'Maßnahmen'" />
                <div class="abstract-info ro-background pa-3 pt-2">
                    <span>{{ current.measure }}</span>
                </div>
            </div>
        </div>
    </div>
</v-container>
